import { useState } from "react";

const Seg = ({ s }) => (s.op === "del"
  ? <del className="bg-red-100 text-red-800 decoration-red-500">{s.t}</del>
  : s.op === "ins" ? <ins className="bg-emerald-100 text-emerald-800 no-underline font-medium">{s.t}</ins> : <span>{s.t}</span>);

const Block = ({ b, i }) => {
  if (b.op === "equal") return <p className="text-slate-600 whitespace-pre-line" data-testid={`diff-eq-${i}`}>{b.text}</p>;
  if (b.op === "insert") return <p className="whitespace-pre-line bg-emerald-50 border-l-4 border-emerald-500 pl-3 py-1 text-emerald-900" data-testid={`diff-ins-${i}`}>{b.text}</p>;
  if (b.op === "delete") return <p className="whitespace-pre-line bg-red-50 border-l-4 border-red-400 pl-3 py-1 text-red-800 line-through" data-testid={`diff-del-${i}`}>{b.text}</p>;
  return (
    <div className="grid md:grid-cols-2 gap-2 border-l-4 border-amber-400 pl-3 py-1 bg-amber-50/40" data-testid={`diff-rep-${i}`}>
      <p className="whitespace-pre-line text-sm"><span className="block text-[10px] uppercase text-slate-400">Avant</span>{b.old.map((s, k) => <Seg key={k} s={s} />)}</p>
      <p className="whitespace-pre-line text-sm"><span className="block text-[10px] uppercase text-slate-400">Après</span>{b.new.map((s, k) => <Seg key={k} s={s} />)}</p>
    </div>
  );
};

export const StatutsDiffView = ({ diff }) => {
  const [onlyChanges, setOnlyChanges] = useState(true);
  if (!diff) return <p className="text-sm text-slate-500">Version d'origine — rien à comparer.</p>;
  const blocks = diff.blocks.map((b, i) => ({ ...b, i })).filter((b) => !onlyChanges || b.op !== "equal");
  return (
    <div className="space-y-2" data-testid="statuts-diff">
      <div className="flex items-center gap-3 text-xs flex-wrap">
        <span className="px-2 py-0.5 rounded bg-amber-100 text-amber-800">{diff.stats.modifies} modifié(s)</span>
        <span className="px-2 py-0.5 rounded bg-emerald-100 text-emerald-800">{diff.stats.ajoutes} ajouté(s)</span>
        <span className="px-2 py-0.5 rounded bg-red-100 text-red-800">{diff.stats.supprimes} supprimé(s)</span>
        <label className="ml-auto flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" checked={onlyChanges} onChange={(e) => setOnlyChanges(e.target.checked)} data-testid="diff-only-changes" />
          Modifications seulement
        </label>
      </div>
      <div className="space-y-2 text-sm leading-relaxed max-h-[50vh] overflow-y-auto pr-2">
        {blocks.length === 0 && <p className="text-slate-500">Aucune différence.</p>}
        {blocks.map((b) => <Block key={b.i} b={b} i={b.i} />)}
      </div>
    </div>
  );
};
